module.exports = __webpack_public_path__ + "img/welding-8.6f23d03a.jpg";